import customFetch from "../util/config/axiosConfig";
import {
  Feature,
  OtherDetailsType,
  SchoolBranchResponse,
  UpdateSchoolBranchPayload,
} from "../types/schoolBranchType";
import { ApiResponse } from "../types/responseType";

const SchoolBranchApis = {
  getAllBranches: async (schoolCode: string): Promise<SchoolBranchResponse> => {
    const response = await customFetch.get(
      `/api/school-branch/get-all/${schoolCode}`,
    );
    return response.data;
  },

  getBranchFeatures: async (
    branchId: number,
  ): Promise<ApiResponse<Feature[]>> => {
    const response = await customFetch.get(
      `/api/school-branch/features/${branchId}?schoolBranchId=${branchId}`,
    );
    return response.data;
  },

  toggleFeature: async (
    branchId: number,
    featureId: number,
  ): Promise<ApiResponse<string>> => {
    const response = await customFetch.patch(
      `/api/school-branch/toggle-feature/${branchId}`,
      featureId,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  },

  getBranchAcademicCycle: async (branchId: number) => {
    try {
      const response = await customFetch.get(
        `/api/school-branch/academic-cycles/${branchId}`,
      );
      return response.data;
    } catch (error) {
      throw error; // bubble up
    }
  },

  toggleAcademicCycle: async (
    branchId: number,
    featureId: number,
  ): Promise<ApiResponse<string>> => {
    const response = await customFetch.patch(
      `/api/school-branch/toggle-academic-cycle/${branchId}`,
      featureId,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  },

  updateBranch: async (branchId: number, data: UpdateSchoolBranchPayload) => {
    const response = await customFetch.put(
      `/api/school-branch/update/${branchId}`,
      data,
      { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
  },

  // Get
  getOtherDetails: async (
    branchId: number,
  ): Promise<ApiResponse<OtherDetailsType>> => {
    const response = await customFetch.get(
      `/api/school-branch/other-academic-preferences/${branchId}`,
    );
    return response.data;
  },

  updateOtherDetails: async (
    branchId: number,
    data: OtherDetailsType,
  ): Promise<ApiResponse<string>> => {
    const response = await customFetch.put(
      `/api/school-branch/other-academic-preferences/${branchId}`,
      data,
      { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
  },

  // Get subjects
  getSubjects: async (branchId: number) => {
    try {
      const response = await customFetch.get(
        `api/school-branch/subjects/${branchId}?schoolBranchId=${branchId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // PUT
  toggleSubjects: async (
    subjectId: number,
    featureId: number,
  ): Promise<ApiResponse<string>> => {
    const response = await customFetch.patch(
      `api/school-branch/toggle-subject/${subjectId}`,
      featureId,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  },

  changeBranchIcon: async (
    branchId: number,
    schoolBranchIcon: string,
  ): Promise<ApiResponse<string>> => {
    const response = await customFetch.patch(
      `/api/school-branch/change-icon/${branchId}`,
      schoolBranchIcon,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      },
    );

    return response.data;
  },
};

export default SchoolBranchApis;
